import React from 'react';
import { translateBlock } from 'i18n';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import TreeItemField from 'routes/Explore/components/Sentence/components/TreeItemField';
import { TreeValue } from 'routes/Explore/components/Sentence/contexts/TreeValueContext';
import {
    CategoryWithTableOnly,
    TableWithFields,
    TreeData,
    UNCLASSIFIED,
} from 'routes/Explore/components/Sentence/helpers/treeData';
import Tables from './Tables';

type Props = {
    domain: string;
    onClick: (field: TreeValue) => void;
    testid: string;
    treeData: TreeData;
};

const Categories = ({
    domain,
    onClick,
    testid,
    treeData,
}: Props): React.ReactElement => {
    // default_time is a field directly beneath the domain. If this becomes more common,
    // we should consider a more generic solution to handle fields at any level.
    const domainChildNodes = treeData[domain];
    const isFields =
        Array.isArray(domainChildNodes) && 'field' in domainChildNodes[0];
    if (isFields) {
        const field = domainChildNodes[0];
        return (
            <TreeItemField
                field={field}
                domain={domain}
                onClick={onClick}
                testid={testid}
                sx={{ '& .MuiTreeItem-content': { pl: 0 } }}
            />
        );
    }
    const sortedCategories = Object.keys(
        domainChildNodes as CategoryWithTableOnly | TableWithFields,
    )
        .map((category) => ({
            value: category,
            label:
                category !== UNCLASSIFIED
                    ? translateBlock(`${domain.toLowerCase()}.${category}`)
                    : '',
        }))
        .sort((a, b) => (a.label > b.label ? 1 : -1));
    const renderCategory = (category: { label: string; value: string }) => (
        <Box sx={{ mt: '0.5rem', mb: '0.6rem' }} key={category.value}>
            <Typography
                variant="body1"
                className="no-flex-shrink"
                color="textSecondary"
            >
                {category.label}
            </Typography>
            <Tables
                treeData={treeData}
                onClick={onClick}
                domain={domain}
                category={category.value}
                testid={testid}
            />
        </Box>
    );

    return <>{sortedCategories.map(renderCategory)}</>;
};

export default Categories;
